import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 16,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M1.94791 6H3.66666V14H1.94791V6ZM6.07291 2H7.79166V14H6.07291V2ZM9.85416 8H11.5729V14H9.85416V8ZM13.9792 3.33333H15.6979V14H13.9792V3.33333ZM18.1042 7.33333H19.8229V14H18.1042V7.33333Z",
			fill: "#5946E5"
		})
	})
});
export default SvgBar;
